/** Specification inputs on the portal watch form. Not required. */
export const PORTAL_FORM_SPECIFICATION_FIELDS = [
  "brand",
  "size",
  "color",
  "family",
  "modelNo",
  "caliber",
];

export function emptyWatchSpecification() {
  return Object.fromEntries(PORTAL_FORM_SPECIFICATION_FIELDS.map((key) => [key, ""]));
}

export function watchSpecificationFrom(doc) {
  const src = doc?.specification && typeof doc.specification === "object" ? doc.specification : {};
  return Object.fromEntries(
    PORTAL_FORM_SPECIFICATION_FIELDS.map((key) => [key, String(src[key] || "").trim()])
  );
}

/** Locked Watch brand names. Must match backend WATCH_PRODUCT_CATEGORIES. */
export const WATCH_BRANDS = [
  "Rolex",
  "Audemars Piguet",
  "Breitling",
  "Hublot",
  "Omega",
  "Patek Philippe",
  "Richard Mille",
  "Tag Heuer",
  "Vacheron Constantin",
  "Cartier",
  "Jaeger-LeCoultre",
  "Panerai",
  "Franck Muller",
  "IWC",
  "Tudor",
  "Breguet",
  "Chopard",
  "Roger Dubuis",
  "Bvlgari",
];
